import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { SpuOfferDetailQuery, SpuOfferDetailVo } from './type';
import { OtherBusinessOfferVo } from '../spu-offer-list/type';

/**
 * 账号、陪玩、代练、装备
 根据offerId查询offer详情
  GET /product/urlMapping/game-service/getOtherBusinessOfferDetailVo
  接口ID：257336686
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336686
 */
export const getSpuOfferDetail = (params: SpuOfferDetailQuery): AxiosPromise<SpuOfferDetailVo> => {
  return request({
    url: '/product/urlMapping/game-service/getOtherBusinessOfferDetailVo',
    method: 'get',
    params
  });
};

// Offer详情页新增Offer推荐列表
export const getRecommendList = (params: { offerId: string }): AxiosPromise<OtherBusinessOfferVo[]> => {
  return request({
    url: '/product/urlMapping/game-service/getRecommendOffer',
    method: 'get',
    params
  });
};
